import React from 'react';
import '../../assets/css/shimmer.css'

const LoaderTimeline = (props) => {
    // console.log(customerCm);

    return (

        <div className='timeline'>
            <div className="timeline-item d-flex position-relative shimmerBox">
                <div className="right-part">
                    <span className="item-period d-block"><div className="shine shimmerLine"></div></span>
                    <span className="item-sub d-block"><div className="shine shimmerLine"></div></span>
                </div>
                <div className="divider-item"></div>
                <div className="left-part">
                    <h5><div className="shine"></div></h5>
                    <div>
                        <div className="shine shimmerLine"></div>
                    </div>
                </div>
            </div>
            <div className="timeline-item d-flex position-relative shimmerBox">
                <div className="right-part">
                    <span className="item-period d-block"><div className="shine"></div></span>
                    <span className="item-sub d-block"><div className="shine"></div></span>
                </div>
                <div className="divider-item"></div>
                <div className="left-part">
                    <h5><div className="shine"></div></h5>
                    <div>
                        <div className="shine shimmerLine"></div>
                    </div>
                </div>
            </div>
            <div className="timeline-item d-flex position-relative shimmerBox">
                <div className="right-part">
                    <span className="item-period d-block"><div className="shine shimmerLine"></div></span>
                    <span className="item-sub d-block"><div className="shine shimmerLine"></div></span>
                </div>
                <div className="divider-item"></div>
                <div className="left-part">
                    <h5><div className="shine shimmerLine"></div></h5>
                    <div>
                        <div className="shine shimmerLine"></div>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default LoaderTimeline;